import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import AccountCircle from "@mui/icons-material/AccountCircle";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import DomainIcon from "@mui/icons-material/Domain";
import HailIcon from "@mui/icons-material/Hail";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import EditIcon from "@mui/icons-material/Edit";
import Button from "@mui/material/Button";
import { UrlApi } from "../../../../../services/apirest";
import { getData, putData } from "../../../../../services/library";
import Notify from "../../../../Notify";
import Grid from "@mui/material/Grid";
import {
  Alert,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Paper,
  Typography,
} from "@mui/material";
import moment from "moment";
import EdicionDatosCli from "./EdicionDatosCli";
import CustomTextField from "../../../componentesReutilizables/CustomTextField";
import BuscadorClienteFactura from "../../BusquedaCliente/BuscadorClienteFactura";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { registrarAccion, DONDE } from "../../../logs/registrarAccion";
import { describirCambiosCliente } from "../../../logs/cambiosCliente";
function DatosCliEnv(props) {
  const [dataCliente, setDataCliente] = useState(props.datos); // Acá se guardan los datos del cliente, que me traigo de Fichacliente(proviene de datosformulario)
  const [color, setColor] = useState("primary");
  const [sitIvaSeleccionada, setSitIvaSeleccionada] = useState("");
  const [tipoClienteSeleccionado, setTipoClienteSeleccionado] = useState("");
  // const [categoriaSeleccionada, setCategoriaSeleccionada] = useState("");
  const [condPagoSeleccionada, setCondPagoSeleccionada] = useState("");
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState("");
  const [provinciaSeleccionada, setProvinciaSeleccionada] = useState("");
  const [localidadSeleccionada, setLocalidadSeleccionada] = useState("");
  const [comercialSeleccionado, setComercialSeleccionado] = useState("");
  const [convenioSeleccionado, setConvenioSeleccionado] = useState("");
  const [usoSeleccionado, setUsoSeleccionado] = useState("");
  const [sucursales, setSucursales] = useState(null);
  const [localidades, setLocalidades] = useState(null);
  const [comerciales, setComerciales] = useState(null);
  const [provincias, setProvincias] = useState(null);
  const [condiciones, setCondiciones] = useState(null);
  // const [categorias, setCategorias] = useState(null);
  const [convenios, setConvenios] = useState(null);
  const [sitIva, setSitIva] = useState(null);
  const [tipoCliente, setTipoCliente] = useState(null);
  const [usos, setUsos] = useState(null);
  const [buscando, setBuscando] = useState(false);
  const [codArg, setCodArg] = useState("");
  //Para cambiar de visualizacion a edicion:
  const [edicion, setEdicion] = useState(false);
  const [disBtn, setDisBtn] = useState(false);
  const [variant, setVariant] = useState("filled");
  const [ROnly, setROnly] = useState(true);
  const [bgColor, setBgColor] = useState("");

  const [checked, setChecked] = useState(
    props.datos.factura_consfinal === 1 ? true : false,
  );
  const [checkedPrecioEspecial, setCheckedPrecioEspecial] = useState(
    props.datos.precio_especial === 1 ? true : false,
  );
  const [clienteFactura, setClienteFactura] = useState(null);
  const [checkedEntregaConRemito, setCheckedEntregaConRemito] = useState(
    props.datos.entrega_con_remito === 1 ? true : false,
  );
  const style = {
    backgroundColor: bgColor,
    width: "100%",
  };
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });

  useEffect(() => {
    props.datos &&
      setDataCliente({
        ...props.datos,
        telefono_1: props.datos.telefono_1
          ? props.datos.telefono_1.replace(/(\+?549)+/g, "").trim()
          : "",
        telefono_2: props.datos.telefono_2
          ? props.datos.telefono_2.replace(/(\+?549)+/g, "").trim()
          : "",
        telefono_3: props.datos.telefono_3
          ? props.datos.telefono_3.replace(/(\+?549)+/g, "").trim()
          : "",
      });
  }, [props.datos]);

  const handleChangeChecked = (event) => {
    setChecked(event.target.checked);
  };

  const handleCheckedPrecioEspecial = (event) => {
    setCheckedPrecioEspecial(event.target.checked);
  };

  useEffect(() => {
    getData("/localidades/prov/" + dataCliente.id_provincia, setLocalidades);
    // if (!(props.datos.id_provincia === dataCliente.id_provincia)) {
    //   dataCliente.id_localidad = "";
    // }
  }, [dataCliente.id_provincia]);

  const editarCliente = () => {
    setEdicion(true);
    setVariant("outlined");
    setROnly(false);
    setBgColor("#ffffff");
  };

  const handleCancel = () => {
    setEdicion(false);
    setVariant("filled");
    setROnly(true);
    setBgColor("");
  };

  const getCodArg = () => {
    fetch(UrlApi + "/desplegables/codArg")
      .then((data) => data.json())
      .then((data) => setCodArg(data[0].valor));
  };

  //Funciones que se ejecutan una sola vez al cargar componente.
  useEffect(() => {
    getData("/tipoclienteenvasado", setTipoCliente);
    // getData("/categorias", setCategorias);
    getData("/convenios", setConvenios);
    getData("/representantes", setComerciales);
    getData("/provincias", setProvincias);
    getData("/condicion_pago", setCondiciones);
    getData("/condiciones_iva/envasado", setSitIva);
    getData("/envasado_usos", setUsos);
    getCodArg();
  }, []);

  useEffect(() => {
    getData("/sucursales", setSucursales);
  }, [dataCliente.id_tipocliente]);

  //use effect para que se carguen las localidades una vez que se setea en el formulario el id_provincia
  //sirve para que solo traiga las localidades de la provincia seleccionada
  useEffect(() => {
    getData("/localidades/prov/" + provinciaSeleccionada.id, setLocalidades);
    if (!(dataCliente.id_provincia === provinciaSeleccionada.id)) {
      setLocalidadSeleccionada("");
    }
    setBuscando(false);
  }, [dataCliente.id_provincia, provinciaSeleccionada]);

  //Funcion para almacenar los datos (se ejecuta en el onchange de los textfield/select)
  // const almacenar = (e) => {
  //   setDataCliente({
  //     ...dataCliente,
  //     [e.target.name]: e.target.value,
  //   });
  // };
  const almacenar = (e) => {
    const { name, value } = e.target;

    // Si el campo es vto_exc_perc_iva y el valor es string vacía, guardar null
    const nuevoValor =
      name === "vto_exc_perc_iva" && value === "" ? null : value;

    setDataCliente({
      ...dataCliente,
      [name]: nuevoValor,
    });
  };

  async function guardarCliente(e) {
    setDisBtn(true);
    let facturaAnombreDe =
      dataCliente.facturar_a === "SELF"
        ? props.datos.id
        : dataCliente.facturar_a;

    const datosGuardar = {
        usuario: localStorage.getItem("user"),
        sisven_id: dataCliente.sisven_id === "" ? null : dataCliente.sisven_id,
        razon_social: dataCliente.razon_social,
        direccion_fiscal: dataCliente.direccion_fiscal,
        telefono_1: dataCliente.telefono_1,
        telefono_2: dataCliente.telefono_2,
        telefono_3: dataCliente.telefono_3,
        mails: dataCliente.mails,
        cuit: dataCliente.cuit,
        id_sucursal: sucursalSeleccionada.id,
        // id_categoria: categoriaSeleccionada.id,
        id_localidad: localidadSeleccionada.id,
        id_comercial: comercialSeleccionado.id,
        // id_provincia: provinciaSeleccionada.id,
        situacion_iva: sitIvaSeleccionada.id,
        id_condicionpago: condPagoSeleccionada.id,
        // limite_credito:
        //   dataCliente.limite_credito === "" ? null : dataCliente.limite_credito,
        id_tipocliente: tipoClienteSeleccionado.id,
        observaciones: dataCliente.observaciones,
        observaciones_cuenta_corriente:
          dataCliente.observaciones_cuenta_corriente,
        // envase_10_kg: dataCliente.envase_10_kg,
        // envase_15_kg: dataCliente.envase_15_kg,
        // envase_45_kg: dataCliente.envase_45_kg,
        uso: usoSeleccionado.id,
        tipo_doc_afip: dataCliente.tipo_doc_afip,
        factura_consfinal: dataCliente.factura_consfinal,
        porc_perc_iva: dataCliente.porc_perc_iva,
        porc_exc_perc_iva: dataCliente.porc_exc_perc_iva,
        vto_exc_perc_iva: dataCliente.vto_exc_perc_iva,
        precio_especial: dataCliente.precio_especial,
        entrega_con_remito: dataCliente.entrega_con_remito,
        facturar_a: facturaAnombreDe,
        id_convenio: convenioSeleccionado.id_convenio,
        iibb_nro_inscripcion: dataCliente.iibb_nro_inscripcion,
      };

    await putData(
      e,
      "/envasado_clientes/" + dataCliente.id,
      datosGuardar,
      setNotificacion,
    );

    // Log de cambios: el "antes" sale de props.datos con la misma limpieza de teléfonos que el useEffect
    const quitar549 = (t) => (t ? t.replace(/(\+?549)+/g, "").trim() : "");
    const orig = {
      ...props.datos,
      telefono_1: quitar549(props.datos.telefono_1),
      telefono_2: quitar549(props.datos.telefono_2),
      telefono_3: quitar549(props.datos.telefono_3),
    };
    const cambios = describirCambiosCliente(
      orig,
      datosGuardar,
      { sucursales, localidades, comerciales, sitIva, condiciones, tipoCliente, usos, convenios },
      {
        sucursal: sucursalSeleccionada,
        localidad: localidadSeleccionada,
        comercial: comercialSeleccionado,
        sitIva: sitIvaSeleccionada,
        condPago: condPagoSeleccionada,
        tipoCliente: tipoClienteSeleccionado,
        uso: usoSeleccionado,
        convenio: convenioSeleccionado,
      }
    );

    if (cambios) {
      registrarAccion(
        DONDE.CLIENTES,
        `Editó cliente ${dataCliente.id} - ${datosGuardar.razon_social} (desde ficha): ${cambios}`
      );
    }
  }

  useEffect(() => {
    // sit Iva
    if (dataCliente.situacion_iva !== "" && sitIva) {
      const sitIvaEncontrada = sitIva.find(
        (d) => d.id === parseInt(dataCliente.situacion_iva),
      );
      if (sitIvaEncontrada) {
        setSitIvaSeleccionada(sitIvaEncontrada);
      }
    }
  }, [sitIva]);

  useEffect(() => {
    // Convenios
    if (dataCliente.id_convenio !== "" && convenios) {
      const convenioEncontrado = convenios.find(
        (d) => d.id_convenio === parseInt(dataCliente.id_convenio),
      );
      if (convenioEncontrado) {
        setConvenioSeleccionado(convenioEncontrado);
      }
    }
  }, [convenios]);

  useEffect(() => {
    // tipo cli
    if (dataCliente.id_tipocliente !== "" && tipoCliente) {
      const tipoClienteEncontrado = tipoCliente.find(
        (d) => d.id === parseInt(dataCliente.id_tipocliente),
      );
      if (tipoClienteEncontrado) {
        setTipoClienteSeleccionado(tipoClienteEncontrado);
      }
    }
  }, [tipoCliente]);

  // useEffect(() => {
  //   // categoria crediticia
  //   if (dataCliente.id_categoria !== "" && categorias) {
  //     const categoriaEncontrada = categorias.find(
  //       (d) => d.id === parseInt(dataCliente.id_categoria),
  //     );
  //     if (categoriaEncontrada) {
  //       setCategoriaSeleccionada(categoriaEncontrada);
  //     }
  //   }
  // }, [categorias]);

  useEffect(() => {
    // condicion pago
    if (dataCliente.id_condicionpago !== "" && condiciones) {
      const condicionEncontrada = condiciones.find(
        (d) => d.id === parseInt(dataCliente.id_condicionpago),
      );
      if (condicionEncontrada) {
        setCondPagoSeleccionada(condicionEncontrada);
      }
    }
  }, [condiciones]);

  useEffect(() => {
    // sucursal
    if (dataCliente.id_sucursal !== "" && sucursales) {
      const sucursalEncontrada = sucursales.find(
        (d) => d.id === dataCliente.id_sucursal,
      );
      if (sucursalEncontrada) {
        setSucursalSeleccionada(sucursalEncontrada);
      }
    }
  }, [sucursales]);

  useEffect(() => {
    // provincia
    if (dataCliente.id_provincia !== "" && provincias) {
      const provinciaEncontrada = provincias.find(
        (d) => d.id === dataCliente.id_provincia,
      );
      if (provinciaEncontrada) {
        setProvinciaSeleccionada(provinciaEncontrada);
      }
    }
  }, [provincias]);

  useEffect(() => {
    // localidad
    if (dataCliente.id_localidad !== "" && localidades) {
      const localidadEncontrada = localidades.find(
        (d) => d.id === dataCliente.id_localidad,
      );
      if (localidadEncontrada) {
        setLocalidadSeleccionada(localidadEncontrada);
      }
      // console.log(
      //   "localidad encontrada",
      //   dataCliente.id_localidad,
      //   localidades,
      //   localidadEncontrada
      // );
    }
  }, [localidades]);

  useEffect(() => {
    // comerciales
    if (dataCliente.id_comercial !== "" && comerciales) {
      const comercialEncontrado = comerciales.find(
        (d) => d.id === dataCliente.id_comercial,
      );
      if (comercialEncontrado) {
        setComercialSeleccionado(comercialEncontrado);
      }
    }
    // }
  }, [comerciales]);

  useEffect(() => {
    // uso
    if (dataCliente.uso !== "" && usos) {
      const usoEncontrado = usos.find((d) => d.id === dataCliente.uso);
      if (usoEncontrado) {
        setUsoSeleccionado(usoEncontrado);
      }
    }
  }, [usos]);

  useEffect(() => {
    let respInscrip = sitIvaSeleccionada?.id === 1 ? 1.75 : null;
    let tieneExencion =
      sitIvaSeleccionada?.id === 1 ? dataCliente.porc_exc_perc_iva : null;
    let vencimientoExencion =
      sitIvaSeleccionada?.id === 1 ? dataCliente.vto_exc_perc_iva : null;

    if (sitIvaSeleccionada?.id === 4) {
      setDataCliente((prev) => ({
        ...prev,
        porc_perc_iva: respInscrip,
        porc_exc_perc_iva: tieneExencion,
        vto_exc_perc_iva: vencimientoExencion,
      }));
    } else if (
      Object.keys(sitIvaSeleccionada).length !== 0 &&
      sitIvaSeleccionada?.id !== 4
    ) {
      setDataCliente((prev) => ({
        ...prev,
        tipo_doc_afip: 80,
        porc_perc_iva: respInscrip,
        porc_exc_perc_iva: tieneExencion,
        vto_exc_perc_iva: vencimientoExencion,
      }));
    }
  }, [sitIvaSeleccionada]);

  useEffect(() => {
    if (props.datos.tipo_doc_afip === dataCliente.tipo_doc_afip) {
      setDataCliente((prev) => ({
        ...prev,
        cuit: props.datos.cuit,
      }));
    } else {
      setDataCliente((prev) => ({
        ...prev,
        cuit: "",
      }));
    }
  }, [dataCliente.tipo_doc_afip]);

  useEffect(() => {
    if (checked === true) {
      setDataCliente((prev) => ({
        ...prev,
        factura_consfinal: 1,
      }));
    } else {
      setDataCliente((prev) => ({
        ...prev,
        factura_consfinal: 0,
      }));
    }
  }, [checked]);

  useEffect(() => {
    if (checkedPrecioEspecial === true) {
      setDataCliente((prev) => ({
        ...prev,
        precio_especial: 1,
      }));
    } else {
      setDataCliente((prev) => ({
        ...prev,
        precio_especial: 0,
      }));
    }
  }, [checkedPrecioEspecial]);

  useEffect(() => {
    if (checkedEntregaConRemito === true) {
      setDataCliente((prev) => ({
        ...prev,
        entrega_con_remito: 1,
      }));
    } else {
      setDataCliente((prev) => ({
        ...prev,
        entrega_con_remito: 0,
      }));
    }
  }, [checkedEntregaConRemito]);

  const handleClienteFacturaChange = (cliente) => {
    setClienteFactura(cliente);

    // Actualizar solo el ID en dataCliente
    if (cliente) {
      setDataCliente((prev) => ({
        ...prev,
        facturar_a: cliente.id,
      }));
    } else {
      setDataCliente((prev) => ({
        ...prev,
        facturar_a: null,
      }));
    }
  };

  useEffect(() => {
    const buscarClienteFacturacion = async () => {
      // Si el cliente tiene facturar_a configurado
      if (props.datos.facturar_a) {
        // Si es 'SELF', crear objeto especial
        if (props.datos.facturar_a === props.datos.id) {
          setClienteFactura({
            id: props.datos.id,
            nombre_cliente_remito: "Facturación Propia",
            razon_social: "Facturación Propia",
          });
        } else {
          try {
            // Para otros casos, buscar el cliente por ID usando fetch
            const response = await fetch(
              `${UrlApi}/envasado_clientes/xid/${props.datos.facturar_a}`,
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  // 'Authorization': `Bearer ${localStorage.getItem('token')}` // si usas autenticación
                },
              },
            );

            if (response.ok) {
              const clienteEncontrado = await response.json();

              if (clienteEncontrado) {
                setClienteFactura({
                  id: clienteEncontrado[0].id,
                  // Si BuscadorClienteFactura usa razon_social, pon el nombre_cliente_remito allí
                  razon_social: clienteEncontrado[0]?.razon_social,
                  // nombre_cliente_remito: clienteEncontrado.nombre_cliente_remito || clienteEncontrado.razon_social,
                  // cuit: clienteEncontrado.cuit
                });
              } else {
                // Si no se encuentra, crear un objeto básico
                setClienteFactura({
                  // id: props.datos.facturar_a,
                  // razon_social: `Cliente ID: ${props.datos.facturar_a}`,
                  // nombre_cliente_remito: `Cliente ID: ${props.datos.facturar_a}`
                });
              }
            } else {
              // Si la respuesta no es exitosa
              console.error(
                "Error en la respuesta del servidor:",
                response.status,
              );
              setClienteFactura({
                // id: props.datos.facturar_a,
                // razon_social: `Cliente ID: ${props.datos.facturar_a}`,
                // nombre_cliente_remito: `Cliente ID: ${props.datos.facturar_a}`
              });
            }
          } catch (error) {
            console.error("Error buscando cliente de facturación:", error);
            setClienteFactura({
              // id: props.datos.facturar_a,
              // razon_social: `Cliente ID: ${props.datos.facturar_a}`,
              // nombre_cliente_remito: `Cliente ID: ${props.datos.facturar_a}`
            });
          }
        }
      } else {
        // Si no tiene facturar_a, limpiar
        setClienteFactura(null);
      }
    };

    buscarClienteFacturacion();
  }, [props.datos.facturar_a]);

  return (
    <div>
      {notificacion && notificacion.open ? (
        <Notify
          mensaje={notificacion.mensaje}
          open={notificacion.open}
          color={notificacion.color}
          handleClose={() => {
            props.tabla(true);
            props.ficha(false);
            props.actualizar();
          }}
          severity={notificacion.severity}
        />
      ) : null}
      <Box>
        <Box
          backgroundColor="#F4F6F6"
          p={1}
          mb={4}
          border={0.5}
          borderColor={"#ABB2B9"}
          borderRadius={4}
        >
          <form onSubmit={guardarCliente}>
            {edicion ? (
              <EdicionDatosCli
                style={style}
                edicion={edicion}
                variant={variant}
                dataCliente={dataCliente}
                color={color}
                ROnly={ROnly}
                tipoCliente={tipoCliente}
                sitIva={sitIva}
                // categorias={categorias}
                convenios={convenios}
                condiciones={condiciones}
                sucursales={sucursales}
                provincias={provincias}
                localidades={localidades}
                comerciales={comerciales}
                usos={usos}
                codArg={codArg}
                disBtn={disBtn}
                checked={checked}
                setChecked={setChecked}
                checkedPrecioEspecial={checkedPrecioEspecial}
                setCheckedPrecioEspecial={setCheckedPrecioEspecial}
                checkedEntregaConRemito={checkedEntregaConRemito}
                setCheckedEntregaConRemito={setCheckedEntregaConRemito}
                buscando={buscando}
                setBuscando={setBuscando}
                sitIvaSeleccionada={sitIvaSeleccionada}
                setSitIvaSeleccionada={setSitIvaSeleccionada}
                tipoClienteSeleccionado={tipoClienteSeleccionado}
                setTipoClienteSeleccionado={setTipoClienteSeleccionado}
                convenioSeleccionado={convenioSeleccionado}
                setConvenioSeleccionado={setConvenioSeleccionado}
                // categoriaSeleccionada={categoriaSeleccionada}
                // setCategoriaSeleccionada={setCategoriaSeleccionada}
                condPagoSeleccionada={condPagoSeleccionada}
                setCondPagoSeleccionada={setCondPagoSeleccionada}
                sucursalSeleccionada={sucursalSeleccionada}
                setSucursalSeleccionada={setSucursalSeleccionada}
                provinciaSeleccionada={provinciaSeleccionada}
                setProvinciaSeleccionada={setProvinciaSeleccionada}
                localidadSeleccionada={localidadSeleccionada}
                setLocalidadSeleccionada={setLocalidadSeleccionada}
                comercialSeleccionado={comercialSeleccionado}
                setComercialSeleccionado={setComercialSeleccionado}
                usoSeleccionado={usoSeleccionado}
                setUsoSeleccionado={setUsoSeleccionado}
                handleCancel={handleCancel}
                handleChangeChecked={handleChangeChecked}
                handleCheckedPrecioEspecial={handleCheckedPrecioEspecial}
                almacenar={almacenar}
                clienteFactura={clienteFactura}
                handleClienteFacturaChange={handleClienteFacturaChange}
              />
            ) : (
              <Grid container spacing={1.5}>
                <Grid item xs={3}>
                  <CustomTextField
                    name="razon_social"
                    label="Razon Social"
                    value={dataCliente.razon_social?.replace(/\b\w/g, (l) =>
                      l.toUpperCase(),
                    )}
                    onChange={almacenar}
                    required={edicion}
                    focused
                    variant={variant}
                    style={style}
                    startAdornment={<AccountCircle />}
                    readOnly={ROnly}
                    maxLength={200}
                  />
                </Grid>

                <Grid item xs={sitIvaSeleccionada?.id === 1 ? 1.5 : 2}>
                  <CustomTextField
                    name="sisven_id"
                    label="Sisven ID"
                    value={dataCliente.sisven_id}
                    onChange={almacenar}
                    style={style}
                    color={color}
                    focused
                    variant={variant}
                    startAdornment={<AccountCircleIcon />}
                    readOnly={ROnly}
                    numeric
                    maxLength={6}
                  />
                </Grid>

                <Grid item xs={sitIvaSeleccionada?.id === 1 ? 1.5 : 3}>
                  <CustomTextField
                    name="tipo_cliente"
                    label="Tipo de Cliente"
                    value={tipoClienteSeleccionado.descripcion}
                    style={style}
                    color={color}
                    focused
                    variant={variant}
                    startAdornment={<AutoStoriesIcon />}
                    readOnly={ROnly}
                  />
                </Grid>

                <Grid item xs={sitIvaSeleccionada?.id === 1 ? 2.5 : 4}>
                  <CustomTextField
                    name="Situacion de Iva"
                    label="Situacion de Iva"
                    value={sitIvaSeleccionada.descripcion}
                    style={style}
                    color={color}
                    focused
                    variant={variant}
                    startAdornment={<AutoStoriesIcon />}
                    readOnly={ROnly}
                  />
                </Grid>

                {sitIvaSeleccionada?.id === 1 && (
                  <>
                    <Grid item xs={1.75}>
                      <CustomTextField
                        name="porc_exc_perc_iva"
                        label="% Exención Perc. IVA"
                        value={dataCliente.porc_exc_perc_iva}
                        style={style}
                        fullWidth
                        focused
                        variant={variant}
                        startAdornment="%"
                        readOnly={ROnly}
                      />
                    </Grid>
                    <Grid item xs={1.75}>
                      <CustomTextField
                        name="vto_exc_perc_iva"
                        label="Vencimiento Exención"
                        value={moment(dataCliente.vto_exc_perc_iva).format(
                          "YYYY-MM-DD",
                        )}
                        style={style}
                        fullWidth
                        focused
                        type="date"
                        variant={variant}
                        readOnly={ROnly}
                      />
                    </Grid>
                  </>
                )}

                {/* <Grid item xs={4}>
                  <CustomTextField
                    name="Categoria Crediticia"
                    label="Categoria Crediticia"
                    value={`${categoriaSeleccionada.categoria} - ${categoriaSeleccionada.descripcion}`}
                    style={style}
                    color={color}
                    focused
                    variant={variant}
                    startAdornment={<AutoStoriesIcon />}
                    readOnly={ROnly}
                  />
                </Grid> */}

                <Grid item xs={3}>
                  <CustomTextField
                    name="cuit"
                    label="Cuit/Dni"
                    value={dataCliente.cuit}
                    style={style}
                    color={color}
                    focused
                    variant={variant}
                    startAdornment={<PersonOutlineIcon />}
                    readOnly={ROnly}
                  />
                </Grid>

                <Grid item xs={3}>
                  <CustomTextField
                    name="id_condicionpago"
                    label="Condición de pago"
                    value={dataCliente.condicion}
                    style={style}
                    color={color}
                    focused
                    variant={variant}
                    startAdornment={<AccountCircleIcon />}
                    readOnly={ROnly}
                  />
                </Grid>

                {/* <Grid item xs={2}>
                  <CustomTextField
                    name="limite_credito"
                    label="Limite de crédito"
                    value={dataCliente.limite_credito}
                    onChange={almacenar}
                    style={style}
                    type="number"
                    color={color}
                    focused
                    variant={variant}
                    startAdornment="$"
                    readOnly={ROnly}
                  />
                </Grid> */}

                <Grid item xs={3}>
                  <CustomTextField
                    name="direccion_fiscal"
                    label="Direccion Fiscal"
                    value={dataCliente.direccion_fiscal}
                    onChange={almacenar}
                    style={style}
                    color={color}
                    focused
                    variant={variant}
                    startAdornment={<LocationOnIcon />}
                    readOnly={ROnly}
                  />
                </Grid>

                <Grid item xs={3}>
                  <CustomTextField
                    name="sucursal"
                    label="Sucursal"
                    value={dataCliente.sucursal}
                    style={style}
                    color={color}
                    focused
                    variant={variant}
                    startAdornment={<DomainIcon />}
                    readOnly={ROnly}
                  />
                </Grid>

                <Grid item xs={3}>
                  <CustomTextField
                    name="provincia"
                    label="Provincia"
                    value={dataCliente.provincia}
                    style={style}
                    color={color}
                    focused
                    variant={variant}
                    startAdornment={<LocationOnIcon />}
                    readOnly={ROnly}
                  />
                </Grid>

                <Grid item xs={3}>
                  <CustomTextField
                    name="localidad"
                    label="Localidad"
                    value={dataCliente.localidad}
                    style={style}
                    color={color}
                    focused
                    variant={variant}
                    startAdornment={<LocationOnIcon />}
                    readOnly={ROnly}
                  />
                </Grid>

                <Grid item xs={4}>
                  <CustomTextField
                    name="representante_comercial"
                    label="Representante Comercial"
                    value={dataCliente.comercial}
                    style={style}
                    color={color}
                    focused
                    variant={variant}
                    startAdornment={<HailIcon />}
                    readOnly={ROnly}
                  />
                </Grid>

                {/* <Grid item xs={2}>
                  <CustomTextField
                    name="envase_10_kg"
                    label="Envase 10 KG"
                    value={dataCliente.envase_10_kg}
                    style={style}
                    color={color}
                    focused
                    variant={variant}
                    readOnly={ROnly}
                  />
                </Grid>

                <Grid item xs={2}>
                  <CustomTextField
                    name="envase_15_kg"
                    label="Envase 15 KG"
                    value={dataCliente.envase_15_kg}
                    style={style}
                    color={color}
                    focused
                    variant={variant}
                    readOnly={ROnly}
                  />
                </Grid>

                <Grid item xs={2}>
                  <CustomTextField
                    name="envase_45_kg"
                    label="Envase 45 KG"
                    value={dataCliente.envase_45_kg}
                    style={style}
                    color={color}
                    focused
                    variant={variant}
                    readOnly={ROnly}
                  />
                </Grid> */}

                <Grid item xs={2}>
                  <CustomTextField
                    name="uso_descripcion"
                    label="Uso"
                    value={dataCliente.uso_descripcion}
                    style={style}
                    color={color}
                    focused
                    variant={variant}
                    readOnly={ROnly}
                  />
                </Grid>

                {sitIvaSeleccionada?.inscripcion_iibb === 1 ? (
                  <>
                    <Grid item xs={3}>
                      <CustomTextField
                        name="convenio"
                        label="Convenio"
                        value={dataCliente.convenio}
                        style={style}
                        color={color}
                        focused
                        variant={variant}
                        readOnly={ROnly}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      <CustomTextField
                        name="iibb_nro_inscripcion"
                        label="N° Inscripción IIBB"
                        value={dataCliente.iibb_nro_inscripcion}
                        style={style}
                        color={color}
                        focused
                        variant={variant}
                        readOnly={ROnly}
                      />
                    </Grid>
                  </>
                ) : null}

                <Grid
                  item
                  xs={sitIvaSeleccionada?.inscripcion_iibb === 1 ? 6 : 12}
                >
                  <CustomTextField
                    name="observaciones"
                    label="Observaciones"
                    value={dataCliente.observaciones}
                    style={style}
                    color={color}
                    focused
                    variant={variant}
                    readOnly={ROnly}
                  />
                </Grid>
                <Grid item xs={12}>
                  <CustomTextField
                    name="observaciones_cuenta_corriente"
                    label="Observaciones cuenta corriente"
                    value={dataCliente.observaciones_cuenta_corriente}
                    style={style}
                    color={color}
                    focused
                    variant={variant}
                    readOnly={ROnly}
                  />
                </Grid>

                <Grid item xs={6}>
                  <CustomTextField
                    name="mails"
                    label="Mails"
                    value={dataCliente.mails}
                    onChange={almacenar}
                    style={style}
                    color={color}
                    focused
                    variant={variant}
                    startAdornment={<ContactMailIcon />}
                    readOnly={ROnly}
                  />
                </Grid>

                <Grid item xs={2}>
                  <CustomTextField
                    name="telefono_1"
                    label="Telefono"
                    value={dataCliente.telefono_1}
                    onChange={almacenar}
                    style={style}
                    type="text"
                    color={color}
                    focused
                    variant={variant}
                    startAdornment={codArg}
                    readOnly={ROnly}
                    numeric
                    maxLength={10}
                  />
                </Grid>

                <Grid item xs={2}>
                  <CustomTextField
                    name="telefono_2"
                    label="Telefono 2"
                    value={dataCliente.telefono_2}
                    onChange={almacenar}
                    style={style}
                    type="text"
                    color={color}
                    focused
                    variant={variant}
                    startAdornment={codArg}
                    readOnly={ROnly}
                    numeric
                    maxLength={10}
                  />
                </Grid>

                <Grid item xs={2}>
                  <CustomTextField
                    name="telefono_3"
                    label="Telefono"
                    value={dataCliente.telefono_3}
                    onChange={almacenar}
                    style={style}
                    type="text"
                    color={color}
                    focused
                    variant={variant}
                    startAdornment={codArg}
                    readOnly={ROnly}
                    numeric
                    maxLength={10}
                  />
                </Grid>

                {/* <Grid item xs={2.4} alignContent={"unset"}>
                  <FormGroup>
                    <FormControlLabel
                      disabled={!edicion}
                      label="Precio Especial"
                      control={
                        <Checkbox
                          checked={checkedPrecioEspecial }
                          onChange={handleCheckedPrecioEspecial}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      }
                    />
                  </FormGroup>
                </Grid> */}
                <Grid item xs={2.5}>
                  <Paper
                    elevation={0}
                    sx={{
                      // p: 0.5,
                      border: "2px solid",
                      borderColor: checkedPrecioEspecial
                        ? "primary.main"
                        : "grey.300",
                      borderRadius: 3,
                      height: 38,
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                      bgcolor: checkedPrecioEspecial
                        ? "primary.50"
                        : "transparent",
                      display: "flex",
                      alignItems: "center",
                      "&:hover": {
                        borderColor: "primary.main",
                        bgcolor: checkedPrecioEspecial
                          ? "primary.100"
                          : "grey.50",
                        transform: "translateY(-2px)",
                        boxShadow: 2,
                      },
                    }}
                    // onClick={() => setCheckedPrecioEspecial((prev) => !prev)}
                  >
                    <Box
                      display="flex"
                      alignItems="center"
                      gap={1.5}
                      width="100%"
                      // onClick={(e) => e.stopPropagation()}
                    >
                      <Checkbox
                        disabled={!edicion}
                        checked={checkedPrecioEspecial}
                        // onChange={handleChangeChecked}
                        tabIndex={-1}
                        disableRipple
                        sx={{
                          "& .MuiSvgIcon-root": { fontSize: 28 },
                        }}
                      />
                      <Typography
                        variant="body1"
                        fontWeight={600}
                        sx={{ userSelect: "none" }}
                      >
                        Precio Especial
                      </Typography>
                    </Box>
                  </Paper>
                  <Typography fontWeight={700} sx={{ mt: 1, ml: 0.5 }}>
                    Fecha alta:{" "}
                    {dataCliente.fecha_alta ||
                      (dataCliente.created_at &&
                      moment(dataCliente.created_at).isValid()
                        ? moment(dataCliente.created_at).format("DD/MM/YYYY")
                        : "No registrada")}
                  </Typography>
                </Grid>

                {/* <Grid item xs={2.4} alignContent={"unset"}>
                  <FormGroup>
                    <FormControlLabel
                      disabled={!edicion}
                      label="Factura Consumidor Final"
                      control={
                        <Checkbox
                          checked={checked}
                          onChange={handleChangeChecked}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      }
                    />
                  </FormGroup>
                </Grid> */}
                <Grid item xs={3}>
                  <Paper
                    elevation={0}
                    sx={{
                      // p: 0.5,
                      border: "2px solid",
                      borderColor: checked ? "primary.main" : "grey.300",
                      borderRadius: 3,
                      height: 38,
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                      bgcolor: checked ? "primary.50" : "transparent",
                      display: "flex",
                      alignItems: "center",
                      "&:hover": {
                        borderColor: "primary.main",
                        bgcolor: checked ? "primary.100" : "grey.50",
                        transform: "translateY(-2px)",
                        boxShadow: 2,
                      },
                    }}
                    // onClick={() => setChecked((prev) => !prev)}
                  >
                    <Box
                      display="flex"
                      alignItems="center"
                      gap={1.5}
                      width="100%"
                      // onClick={(e) => e.stopPropagation()}
                    >
                      <Checkbox
                        checked={checked}
                        disabled={!edicion}
                        // onChange={handleChangeChecked}
                        tabIndex={-1}
                        disableRipple
                        sx={{
                          "& .MuiSvgIcon-root": { fontSize: 28 },
                        }}
                      />
                      <Typography
                        variant="body1"
                        fontWeight={600}
                        sx={{ userSelect: "none" }}
                      >
                        Factura Consumidor Final
                      </Typography>
                    </Box>
                  </Paper>
                </Grid>

                <Grid item xs={2.5}>
                  <Paper
                    elevation={0}
                    sx={{
                      // p: 0.5,
                      border: "2px solid",
                      borderColor: checkedEntregaConRemito
                        ? "primary.main"
                        : "grey.300",
                      borderRadius: 3,
                      height: 38,
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                      bgcolor: checkedEntregaConRemito
                        ? "primary.50"
                        : "transparent",
                      display: "flex",
                      alignItems: "center",
                      "&:hover": {
                        borderColor: "primary.main",
                        bgcolor: checkedEntregaConRemito
                          ? "primary.100"
                          : "grey.50",
                        transform: "translateY(-2px)",
                        boxShadow: 2,
                      },
                    }}
                    // onClick={handleCheckedEntregaConRemito}
                    // onClick={() => setCheckedEntregaConRemito((prev) => !prev)}
                  >
                    <Box
                      display="flex"
                      alignItems="center"
                      gap={1.5}
                      width="100%"
                      // onClick={(e) => e.stopPropagation()}
                    >
                      <Checkbox
                        disabled={!edicion}
                        checked={checkedEntregaConRemito}
                        // onChange={handleCheckedEntregaConRemito}
                        tabIndex={-1}
                        disableRipple
                        sx={{
                          "& .MuiSvgIcon-root": { fontSize: 28 },
                        }}
                      />
                      <Typography
                        variant="body1"
                        fontWeight={600}
                        sx={{ userSelect: "none" }}
                      >
                        Entrega con Remito
                      </Typography>
                    </Box>
                  </Paper>
                </Grid>

                {(checkedEntregaConRemito || clienteFactura) && (
                  <Grid item xs={12} md={4}>
                    {/* <BuscadorClienteFactura
                      value={clienteFactura}
                      onChange={handleClienteFacturaChange}
                      style={style}
                      size={"small"}
                      label="Facturar a"
                      placeholder="Buscar cliente por razón social, CUIT..."
                    /> */}
                    <CustomTextField
                      name="Facturar a"
                      label="facturar_a"
                      value={clienteFactura?.razon_social}
                      style={style}
                      color={color}
                      focused
                      variant={variant}
                      // startAdornment={<HailIcon />}
                      readOnly={ROnly}
                    />
                  </Grid>
                )}
                
                {props.isEditable?(
                  <Grid container justifyContent="end">
                  <Grid item xs={2} mt={1}>
                    <Button
                      fullWidth
                      disabled={edicion}
                      onClick={editarCliente}
                      variant="outlined"
                      startIcon={<EditIcon />}
                    >
                      Editar cliente
                    </Button>
                  </Grid>
                </Grid>
                ):(
                  <Grid container justifyContent="center" sx={{ mt: 4, mb: 2, ml:2, mr:2}}>
  <Grid item xs={12} textAlign="center">
    <Alert severity="info" icon={<InfoOutlinedIcon />}>
      <Typography variant="body1" fontWeight={500}>
        No tenes permisos para editar el cliente
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Este cliente pertenece a otra sucursal
      </Typography>
    </Alert>
  </Grid>
</Grid>
                )}
                
              </Grid>
            )}
          </form>
        </Box>
      </Box>
    </div>
  );
}

export default DatosCliEnv;
